module.exports = __webpack_public_path__ + "static/media/11_tn.3108ce20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/11_tn.jpg
// module id = 225
// module chunks = 0